module.exports = __webpack_public_path__ + "img/currency2.92b3c58c.png";